import { render, staticRenderFns } from "./LandingServiceItem.vue?vue&type=template&id=cb08ce96&scoped=true"
import script from "./LandingServiceItem.vue?vue&type=script&lang=js"
export * from "./LandingServiceItem.vue?vue&type=script&lang=js"
import style0 from "./LandingServiceItem.vue?vue&type=style&index=0&id=cb08ce96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb08ce96",
  null
  
)

export default component.exports